<template>
  <section :ref="'Car_' + name" :class="showInfo ? 'CarWrapper CarWrapperOpen' : 'CarWrapper'">
    <div class="Hero">
      <h3 class="CarYear">{{ year }}</h3>
      <div class="CarSpacer" />
      <div class="ImageWrapper">
        <img :src="image" />
      </div>
      <div class="CarModel">
        <h2>{{ name.replace('Porsche ', '') }}</h2>
        <button @click="showInfo = !showInfo">
          {{ showInfo ? 'Fermer' : 'Infos' }}
        </button>
      </div>
    </div>
    <div
      v-if="showInfo"
      :key="infos"
      :class="isTransitionCompleted ? 'CarInfos CarInfosOpen' : 'CarInfos'"
      v-html="infos"
    />
  </section>
</template>

<script>
export default {
  name: 'Car',

  props: {
    car: { type: Object, required: true },
    year: { type: String, required: true }
  },

  data: () => ({
    isTransitionCompleted: false,
    showInfo: false
  }),

  computed: {
    name() {
      return this.car.name;
    },
    image() {
      return this.car.img;
    },

    infos() {
      let text = '';

      this.car.description.forEach(t => {
        const t1 = t.replace(/Porsche/g, '<strong>Porsche</strong>');
        text += `<p class="CarInfo">${t1}</p>`;
      });

      return text;
    }
  },

  watch: {
    showInfo() {
      this.isTransitionCompleted = false;
      this.$emit('car-change', this.name);
      setTimeout(() => {
        this.isTransitionCompleted = true;
        this.$emit('update-style');
      }, 500);
    }
  }
};
</script>

<style lang="scss">
.CarWrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 0;
  flex-basis: 30%;
  transition: flex-basis 800ms ease-in-out;

  &.CarWrapperOpen {
    flex-basis: 60%;

    @include respond(small) {
      flex-basis: 90%;
    }
  }

  .Hero {
    display: flex;
    flex-direction: column;
    min-width: 400px;
    max-width: 400px;
    height: 100%;
    padding: 0 75px;
    border-left: 1px solid rgb(235, 235, 235);
    text-align: left;

    @include respond(small) {
      min-width: 300px;
      padding: 0 20px;
    }

    @include respond(tablet) {
      min-width: 200px;
    }

    .CarSpacer {
      flex-grow: 1;
    }

    .CarYear {
      color: $color-accent;
      font-size: 3rem;
      padding: 50px 0;
    }
    .CarModel {
      color: rgb(77, 77, 77);
      font-size: 1.5rem;
      padding: 100px 0;

      button {
        color: $color-accent;
        font-weight: bold;
        cursor: pointer;
        margin-top: 20px;
        padding: 10px 30px;
        background-color: transparent;
        border: 2px solid $color-accent;
        border-radius: 5px;
        font-size: 1rem;
        transition: 100ms all ease-in-out;

        &:focus,
        &:active,
        &:visited {
          outline: none;
        }

        &:hover {
          color: white;
          background-color: $color-accent;
        }
      }
    }

    .ImageWrapper {
      width: 100%;
      height: 200px;
      max-height: 500px;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }

  .CarInfos {
    width: 0;
    opacity: 0;
    max-height: 80%;
    padding-right: 0;
    text-align: left;
    overflow-y: auto;
    overflow-x: hidden;
    transition: opacity 1.5s ease-in-out;

    &.CarInfosOpen {
      opacity: 1;
      width: auto;
      padding-right: 75px;

      @include respond(small) {
        padding-right: 20px;
      }
    }

    .CarInfo {
      padding: 10px 0;
    }
  }
}
</style>
